import { DateTimeField } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { MentionSelect } from '../../../../components/mention-select/MentionSelect';

export function LiveMentionsForm(p: object) {
  const { $t } = useIntl();
  const tz = useTimezone();
  const station = useActiveStation();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DateTimeField
            name="from"
            dateLabel={$t({
              id: 'common.dateStart',
              defaultMessage: 'Fecha inicio',
            })}
            timeLabel={$t({
              id: 'common.timeStart',
              defaultMessage: 'Hora inicio',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
        <div className="col-4">
          <DateTimeField
            name="to"
            dateLabel={$t({
              id: 'common.dateEnd',
              defaultMessage: 'Fecha fin',
            })}
            timeLabel={$t({
              id: 'common.timeEnd',
              defaultMessage: 'Hora fin',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
      </div>
      <div className="col-4 p-0">
        <MentionSelect
          stationId={station.id}
          label={$t({
            id: 'common.name',
            defaultMessage: 'Nombre',
          })}
          name="name"
        />
      </div>
    </div>
  );
}
